import Swal from "sweetalert2";

export const showAlert = ({
  title = "Upsss!!!",
  text,
  icon = "warning",
  confirmButtonText = "Aceptar",
  cancelButtonText = null,
  callAction = null,
  cancelAction = null,
}) => {
  const props = {
    title,
    text,
    icon,
    confirmButtonText,
    confirmButtonColor: "#6a00ff",
  };
  if (cancelButtonText) {
    props.showCancelButton = true;
    props.cancelButtonText = cancelButtonText;
    props.cancelButtonColor = "#000000";
  }
  Swal.fire(props).then((res) => {
    if (res.value && callAction) {
      callAction();
    }
    if (res.dismiss === "cancel" && cancelAction) {
      cancelAction();
    }
  });
};
